import { isFieldEmpty } from "@limitless/common/utils";
import { isPasswordValid, areFieldsPristine, PASSWORD_VALIDATION_MESSAGE } from "../FieldValidators";

/**
 * Validates the user inputs of the password reset code form
 *
 * @param {object} fields
 */
export const validatePasswordResetCodeForm = (fields, errorMessage, validatePassword) => {
  const fieldErrors = {};
  const userErrorMessage = errorMessage;

  //If the all the fields are pristine, don't show any errors
  if (areFieldsPristine(fields)) {
    return {
      fieldErrors,
      isFormInvalid: true,
      userErrorMessage
    };
  }
  const {
    registrationCode,
    password
  } = fields;
  if (!registrationCode.pristine && isFieldEmpty(registrationCode.value)) {
    fieldErrors.registrationCode = "Please enter your registration code";
  }
  if (!registrationCode.pristine && registrationCode.value && registrationCode.value.length !== 6) {
    fieldErrors.registrationCode = "Your registration code should be 6 characters";
  }
  if (validatePassword && password.value && !isPasswordValid(password.value)) {
    fieldErrors.password = PASSWORD_VALIDATION_MESSAGE;
  }
  if (validatePassword && !password.value) {
    //this should never be seen by the user
    fieldErrors.password1 = "Password invalid";
  }
  const isFormInvalid = Object.keys(fieldErrors).length > 0;
  return {
    fieldErrors,
    isFormInvalid,
    userErrorMessage
  };
};